import { render, staticRenderFns } from "./PublishedBadge.vue?vue&type=template&id=474a99b2&"
import script from "./PublishedBadge.vue?vue&type=script&lang=js&"
export * from "./PublishedBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports